import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Space } from 'antd';
import { SectionCard, SectionHeader, SectionTitle, ViewAllButton, CloseButton, StyledCollapse } from './styles';
import { DASHBOARD_ROUTES, BUTTON_LABELS } from './constants';
import { ItemsSectionProps } from './types';
import { useTheme } from '../../../context/ThemeContext';

const { Panel } = StyledCollapse;

const ItemsSection: React.FC<ItemsSectionProps> = ({
  isOpen,
  onClose,
  isLoading = false,
  itemsCount = 0,
  soldOutCount = 0,
}) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  const handleViewMenu = () => {
    if (!isLoading) {
      navigate(DASHBOARD_ROUTES.MENU);
    }
  };

  const handleViewAll = () => {
    if (!isLoading) {
      navigate(DASHBOARD_ROUTES.ITEMS);
    }
  };

  return (
    <StyledCollapse
      activeKey={isOpen ? ['items'] : []}
      ghost
      expandIcon={() => null}
    >
      <Panel key="items" header={null}>
        <SectionCard>
          <SectionHeader>
            <SectionTitle level={4}>Items Management</SectionTitle>
            <CloseButton
              type="text"
              icon={<CloseOutlined />}
              onClick={onClose}
              aria-label="Close"
            />
          </SectionHeader>

          {/* Two-column stat layout */}
          <Row gutter={16} style={{ marginBottom: 20 }}>
            <Col span={12}>
              <div style={{ textAlign: 'center', padding: '16px', borderRadius: 8 }}>
                <div style={{ fontSize: 32, fontWeight: 800, color: '#48BB78' }}>{itemsCount}</div>
                <div style={{
                  fontSize: 12,
                  color: isDarkMode ? '#a0aec0' : '#718096',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}>
                  Total Items
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ textAlign: 'center', padding: '16px', borderRadius: 8 }}>
                <div style={{
                  fontSize: 32,
                  fontWeight: 800,
                  color: soldOutCount > 0 ? '#F56565' : '#48BB78',
                }}>
                  {soldOutCount}
                </div>
                <div style={{
                  fontSize: 12,
                  color: isDarkMode ? '#a0aec0' : '#718096',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}>
                  Sold Out
                </div>
              </div>
            </Col>
          </Row>

          <Space direction="vertical" style={{ width: '100%' }}>
            <ViewAllButton type="primary" onClick={handleViewMenu} disabled={isLoading} block>
              {BUTTON_LABELS.VIEW_MENU}
            </ViewAllButton>
            <ViewAllButton type="default" onClick={handleViewAll} disabled={isLoading} block>
              {BUTTON_LABELS.VIEW_ALL_ITEMS}
            </ViewAllButton>
            {soldOutCount > 0 && (
              <ViewAllButton
                type="default"
                onClick={() => navigate('/items?filter=sold_out')}
                disabled={isLoading}
                block
              >
                {BUTTON_LABELS.VIEW_SOLD_OUT}
              </ViewAllButton>
            )}
          </Space>
        </SectionCard>
      </Panel>
    </StyledCollapse>
  );
};

export default ItemsSection;
